import React from 'react';
import { Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0B] border-t border-white/5 py-12" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-67">
          <div className="text-center md:text-left" data-id="element-68">
            <span className="text-xl font-semibold tracking-tight text-white" data-id="element-69">
              Archaitechs
            </span>
            <p className="text-sm font-light text-zinc-500 mt-2" data-id="element-70">
              © 2024 Archaitechs. Alle Rechte vorbehalten.
            </p>
          </div>

          <div className="flex items-center gap-8" data-id="element-71">
            <a href="#" className="text-sm font-light text-zinc-500 hover:text-white transition-colors" data-id="element-72">
              Impressum
            </a>
            <a href="#" className="text-sm font-light text-zinc-500 hover:text-white transition-colors" data-id="element-73">
              Datenschutz
            </a>
            <a href="#" className="text-zinc-500 hover:text-blue-400 transition-colors" data-id="element-74">
              <Linkedin className="w-5 h-5" data-id="element-75" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}